import React from 'react';
import clsx from 'clsx';

/**
 * EmptyState — friendly placeholder when there's no data.
 *
 * <EmptyState
 *   icon={<Inbox />}
 *   title="אין כאן עדיין כלום"
 *   description="ברגע שתצטרפ/י לקהילה ראשונה, תראה כאן את העדכונים שלה."
 *   action={<Button>הצטרף לקהילה</Button>}
 * />
 */
export function EmptyState({
    icon,
    title,
    description,
    action,
    secondaryAction,
    className,
    size = 'md',
}) {
    const sz = {
        sm: { icon: 'w-10 h-10', wrap: 'py-8',  iconBox: 'w-14 h-14', gap: 'space-y-3' },
        md: { icon: 'w-12 h-12', wrap: 'py-12', iconBox: 'w-20 h-20', gap: 'space-y-4' },
        lg: { icon: 'w-14 h-14', wrap: 'py-16', iconBox: 'w-24 h-24', gap: 'space-y-5' },
    }[size] || { icon: 'w-12 h-12', wrap: 'py-12', iconBox: 'w-20 h-20', gap: 'space-y-4' };

    return (
        <div className={clsx('flex flex-col items-center justify-center text-center', sz.wrap, sz.gap, className)}>
            {icon && (
                <div className={clsx('flex items-center justify-center rounded-pill bg-brand-50 text-brand-600', sz.iconBox)}>
                    <span className={sz.icon}>{icon}</span>
                </div>
            )}
            <div className="max-w-md space-y-1.5">
                {title && <h3 className="heading-sm text-ink">{title}</h3>}
                {description && <p className="text-sm text-ink-muted leading-relaxed">{description}</p>}
            </div>
            {(action || secondaryAction) && (
                <div className="flex flex-wrap items-center justify-center gap-3 pt-2">
                    {action}
                    {secondaryAction}
                </div>
            )}
        </div>
    );
}

export default EmptyState;
